import cn from '../utils/cn';
import KoobButton from './KoobButton';
import KoobModal from './KoobModal';
import { useTranslation } from 'react-i18next';

interface KoobConfirmationModalProps {
  open: any;
  setOpen: any;
  title: any;
  description?: any;
  onConfirm: any;
  danger?: boolean;
  confirmLabel?: any;
  cancelLabel?: any;
  children?: any;
}

export default function KoobConfirmationModal({
  open,
  setOpen,
  title,
  description,
  onConfirm,
  danger = false,
  confirmLabel,
  cancelLabel,
  children,
}: KoobConfirmationModalProps) {
  const { t } = useTranslation('misc');
  const handleClose = () => {
    setOpen(false);
  };

  // The UI kit's confirmation: a tinted round icon beside the question, the
  // two buttons at the bottom right.
  return (
    <KoobModal
      open={open}
      setOpen={setOpen}
      widthClass="sm:max-w-[480px]"
      showCloseIcon
    >
      <div className="flex items-start gap-4 pr-8">
        <span
          className={cn(
            'flex size-11 flex-none items-center justify-center rounded-full text-lg',
            danger ? 'bg-red-100 text-red-700' : 'bg-navy-100 text-k-h',
          )}
        >
          <i
            className={cn(
              'fa-solid',
              danger ? 'fa-triangle-exclamation' : 'fa-circle-question',
            )}
          />
        </span>
        <div className="flex flex-1 flex-col gap-2">
          <h2 className="m-0 text-lg font-semibold text-k-h">{title}</h2>
          {description && (
            <p className="m-0 text-sm leading-[22px] text-k-body">
              {description}
            </p>
          )}
        </div>
      </div>

      {children && <div className="mt-5">{children}</div>}

      <div className="mt-6 flex justify-end gap-3">
        <KoobButton variant="secondary" onClick={handleClose}>
          {cancelLabel || t('cancel')}
        </KoobButton>

        {onConfirm && (
          <KoobButton
            onClick={() => onConfirm()}
            variant={danger ? 'danger' : 'primary'}
            data-testid="confirm-button"
          >
            {confirmLabel || t('confirm')}
          </KoobButton>
        )}
      </div>
    </KoobModal>
  );
}
